import _slicedToArray from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Vue from 'vue';
import Router from 'vue-router';
import '@/core/storage';
import store from '@/store';
import auth, { getToken, setToken } from '@/utils/auth';
import NProgress from 'nprogress';
import 'assets/css/nprogress.scss';
import Utils from '@/utils/utils';
import App from '@/utils/app';
/* Layout*/
import RootLayout from '@/layouts/RootLayout';
/* Router Modules */
import account from './modules/account';
import special from './modules/special';
import activity from './modules/activity';
import active from './modules/active';
import native from './modules/native';
import other from './modules/other';
import user from './modules/user';
import auction from './modules/auction';
import assets from './modules/assets';
import setting from './modules/setting';
import coupon from './modules/coupon';
import virtual from './modules/virtual';
import crowdfundingMall from './modules/crowdfundingMall';
import copyrightCollect from './modules/copyrightCollect';
import find from './modules/find';
import partyPlanet from './modules/partyPlanet';
import forward from './modules/forward';
import miniGame from './modules/miniGame';
import microApp from '@/router/modules/microApp';
import without from '@/router/modules/without';
import tinyPlanet from '@/router/modules/tinyPlanet';
import sourceCastle from '@/router/modules/sourceCastle';
import leapGenBurg from '@/router/modules/leapGenBurg';
import evolution from '@/router/modules/evolution';
import energy from '@/router/modules/energy';
import project from '@/router/modules/project';
import bid from '@/router/modules/bid';
import drawCards from '@/router/modules/drawCards';
import { microAppList } from '@/micro';

// hack router push callback
var originalPush = Router.prototype.push;
var originalBack = Router.prototype.back;
var originalGo = Router.prototype.go;
var originalReplace = Router.prototype.replace;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(function (err) {
    return err;
  });
};
// replace
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(function (err) {
    return err;
  });
};
Router.prototype.back = function (arg) {
  if (window.history.length <= 1) {
    originalReplace.call(this, '/');
  } else {
    originalBack.call(this, arg);
  }
};
Router.prototype.go = function (index) {
  if (index < 0 && Math.abs(index) >= window.history.length) {
    originalReplace.call(this, '/');
  } else {
    originalGo.call(this, index);
  }
};
Vue.use(Router);

/**
 * 基础路由
 * @type { *[] }
 */
export var constantRouter = [{
  path: '/',
  component: RootLayout,
  redirect: '/home',
  children: [{
    path: '/home',
    name: 'Home',
    component: function component() {
      return import('views/home/Index');
    },
    meta: {
      title: '首页'
      // keepAlive: true
    }
  }, {
    path: '/404',
    name: 'Page404',
    component: function component() {
      return import('views/error/404');
    },
    meta: {
      title: '404'
    }
  }]
}, account, auction, special, assets, activity, active, native, other, user, coupon, setting, virtual, crowdfundingMall, copyrightCollect, find, partyPlanet, forward, miniGame, microApp,
// fActivity,
without, tinyPlanet, sourceCastle, evolution, energy, leapGenBurg, project, drawCards, bid
// 放在最后
// {
//   path: '*',
//   redirect: '/404'
// }
];
var createRouter = function createRouter() {
  return new Router({
    mode: 'history',
    // base: process.env.BASE_URL,
    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
      if (savedPosition && to.meta.keepAlive) {
        return savedPosition;
      }
      return {
        x: 0,
        y: 0
      };
    },
    routes: constantRouter
  });
};
var router = createRouter();

// 全局路由钩子
var childrenPath = microAppList.map(function (x) {
  return x.activeRule;
});
router.beforeEach(function (to, from, next) {
  // start progress bar
  NProgress.start();
  // set page title
  var _to$meta = to.meta,
    _to$meta$auth = _to$meta.auth,
    auth = _to$meta$auth === void 0 ? false : _to$meta$auth,
    _to$meta$title = _to$meta.title,
    title = _to$meta$title === void 0 ? '' : _to$meta$title;
  document.title = Utils.getPageTitle(title);
  if (to.name) {
    var token = getToken();
    // 目标页面如果需要授权直接拦截，默认不拦截
    if (!token && auth) {
      // 解决从外链进来 被登录拦截 后 登录成功进去目标页面
      var fullPath = to.fullPath;
      return next("/login?redirect=".concat(window.encodeURIComponent(fullPath)));
    }
    // 已登录状态不能访问登录页
    if (token && to.name === 'Login') {
      var _to$query$redirect = to.query.redirect,
        redirect = _to$query$redirect === void 0 ? '' : _to$query$redirect;
      return next(redirect || {
        name: 'AccountIndex'
      }); // 如果有重定向页面 就去重定向页面
    }
    // 有 name 属性，说明是主应用的路由
    return next();
  } else {
    if (childrenPath.some(function (item) {
      return to.path.includes(item);
    })) {
      return next();
    }
    return next('/home');
  }
});
router.afterEach(function (to) {
  // finish progress bar
  NProgress.done();
  if (to.meta.keepAlive) {
    store.commit('user/SET_KEEP_ALIVE', to.name);
  }
});

// 路由准备完成后查询数据
router.onReady(function () {
  // 获取系统通用配置
  var prod_config = localStorage.getItem('prod_config');
  if (!prod_config || prod_config && JSON.parse(prod_config).expirationTime < Date.now()) {
    store.dispatch('app/GetConfig');
  } else {
    store.commit('app/SET_CONFIG', JSON.parse(prod_config).value);
  }
  // 实时获取应用通用配置，邀请好友交易金额后端需要动态更新
  // if (!auth.getAppConfig()) {
  store.dispatch('app/GetAppConfig');
  // }

  /*
   * 过滤路由配置中带normal的配置
   * 如果是目标页面就不进行接口查询
   * */
  var filterQuery = constantRouter.reduce(function (prev, next) {
    if (next.children) {
      prev = prev.concat(next.children);
    }
    return prev;
  }, []).filter(function (x) {
    return x.meta && x.meta.normal;
  });
  var isNormal = filterQuery.some(function (x) {
    var _x$path$split = x.path.split('/'),
      _x$path$split2 = _slicedToArray(_x$path$split, 1),
      url = _x$path$split2[0];
    return window.location.pathname.includes(url);
  });
  // 如果不是普通页面
  if (!isNormal) {
    // 每次刷新重新获取用户信息
    if (Utils.appInfo) {
      App.getToken({}, function (data) {
        // 设置token
        store.commit('user/SET_TOKEN', data);
        setToken(data);
        if (data) {
          store.dispatch('user/GetUserInfo');
          store.dispatch('user/GetTradePwd');
          store.dispatch('user/GetRealNameInfo');
          store.dispatch('user/GetWalletStatus');
          store.dispatch('user/GetUserWalletList');
        } else {
          store.dispatch('user/Reset');
        }
      });
    } else if (getToken()) {
      if (!auth.lsGetUserInfo()) {
        store.dispatch('user/GetUserInfo');
      }
      if (!auth.lsGetTradePwd()) {
        store.dispatch('user/GetTradePwd');
      }
      if (!auth.lsGetRealNameInfo()) {
        store.dispatch('user/GetRealNameInfo');
      }
      if (!auth.lsGetFYWalletInfo()) {
        store.dispatch('user/GetWalletStatus');
      }
      if (!auth.lsGetUserWalletList()) {
        store.dispatch('user/GetUserWalletList');
      }
    }
  }
});
export default router;